import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { all_routes } from "./router/all_routes";
import Header from "./Header";
import Swal from "sweetalert2";
import { ProductContext } from "../context/AppContext";
import ImageWithBasePath from "../core/common/imageWithBasePath";

const Examschedule = () => {
  const params = useParams();
  const routes = all_routes;
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [loadingcancel, setLoadingCancel] = useState(false);
  const [success, setSuccess] = useState(false);
  const authtoken = localStorage.getItem("token");
  const { dataNew, getRegistration } = useContext(ProductContext);
  const classIdNew = localStorage.getItem("ClassId");
  const [getExamData, setGetExamData] = useState(null);
  const [getExamNewData, setGetExamNewData] = useState(null);
    const RegistrationId = getRegistration?.data?.id;


  const fetchUserClassData = () => {
    fetch(`https://api.mirai.healthcare/api/exam?class_id=${classIdNew}`, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        "x-auth": `${authtoken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((response) => {
        setGetExamData(response);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  };

  const fetchUserNewData = () => {
    fetch(`https://api.mirai.healthcare/api/exam-booking/user-booking`, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        "x-auth": `${authtoken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((response) => {
        setGetExamNewData(response);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  };

  useEffect(() => {
    fetchUserClassData();
    fetchUserNewData();
  }, [authtoken]);

  const handleSubmit = (examId) => {
    navigate(`/applyentrancere/${examId}`);
  };



  const handleReschedule = async (bookingId, examId) => {
    navigate(`/applyreschedule/${bookingId}/${examId}`);
  };

  const handleCancelApi = async (bookingId) => {
    if (!bookingId) {
      // console.error("Booking ID is missing");
      alert("Booking ID is missing!");
      return;
    }

    // console.log("Clicked Reschedule for Booking ID:", bookingId);
    setLoadingCancel((prev) => ({ ...prev, [bookingId]: true }));

    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/exam-booking/${bookingId}`,
        {
          method: "PUT",
          headers: {
            "x-auth": `${authtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            status: "cancel",
            reg_id:RegistrationId,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        await Swal.fire({
          title: "Success",
          text: `Booking ID ${bookingId} Cancel successfully!`,
          icon: "success",
        });
        fetchUserClassData();
      } else {
        console.error("Failed to reschedule:", result);
        alert(`Failed to reschedule Booking ID ${bookingId}!`);
      }
    } catch (error) {
      console.error("Error rescheduling:", error);
    } finally {
      setLoadingCancel((prev) => ({ ...prev, [bookingId]: false }));
    }
  };

  const fetchExamDownloadData = async (examId) => {
  try {

    const response = await fetch(
      `https://api.mirai.healthcare/api/exam/syllabus?exam_id=${examId}`,
      {
        method: "GET",
        headers: {
          "x-auth": `${authtoken}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    console.log("Exam Syllabus Data:", data);

    // ✅ Check if exam file exists
    const examFile = data?.message?.exams?.[0]?.file_url?.link;

    // if (examFile) {
    //   // ✅ If file found, trigger download
    //   const fileName = examFile.split("/").pop();
    //   const link = document.createElement("a");
    //   link.href = examFile;
    //   link.download = fileName || "exam-file";
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // } else {
    //   // ✅ If no file found, print message
    //   console.log("No file found for this exam.");
    //   alert("No file found for this exam.");
    // }
    if (examFile) {
      // ✅ Open in new tab instead of downloading
      window.open(examFile, "_blank", "noopener,noreferrer");
    } else {
      console.log("No file found for this exam.");
      alert("No file found for this exam.");
    }
  } catch (error) {
    console.error("Error fetching exam data:", error);
  }
};



  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        {getExamData ? (
        <div className="content background-color_row">
          <>
            <Header />

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header card-buttons">
                    <h5 className="card-title">Exam Schedule</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {getExamData?.message?.exam?.map((examdata, index) => {
                        return (
                          <div className="col-12 col-sm-6 col-md-4" key={index}>
                            {examdata?.is_slot_booked === false ? (
                              <div className="card">
                                <div className="card-header card-buttons">
                                  <h5 className="card-title exam_name_heading">
                                    Exam Name <span>{examdata?.name}</span>
                                  </h5>
                                </div>
                                <div className="card-body Card_design_1">
                                  <p>
                                    Class Name
                                    <span>{examdata?.class?.Classes}</span>
                                  </p>
                                  <p>
                                    Subject Name
                                    <span>{examdata?.subject?.name}</span>
                                  </p>
                                  <p>
                                    Age<span>{examdata?.class?.Age_Group}</span>
                                  </p>
                                
                                  <div className="d-flex align-items-end book_slot">
                                    <button
                                      className="d-flex align-items-center me-2 btn btn-primary"
                                      onClick={() => fetchExamDownloadData(examdata?.id)}
                                    >
                                      Download
                                    </button>

                                  {getRegistration?.data?.registration_fee_status === "paid" && (
                                    <button
                                      className="d-flex align-items-center btn btn-primary"
                                      onClick={() => handleSubmit(examdata?.id)}
                                    >
                                      Book Slot
                                    </button>
                                    )}
                                  </div>
                                
                                </div>
                              </div>
                            ) : (
                              <div className="card card_background">
                                <div className="card-header card-buttons">
                                  <h5 className="card-title exam_name_heading">
                                    Exam Name <span>{examdata?.name}</span>
                                  </h5>
                                </div>
                                <div className="card-body Card_design_1">
                                  <p>
                                    Class
                                    <span>{examdata?.class?.Classes}</span>
                                  </p>
                                  <p>
                                    Subject Name
                                    <span>{examdata?.subject?.name}</span>
                                  </p>
                                  <p>
                                    Exam Date
                                    <span>
                                      {new Date(
                                        examdata?.exam_booking_audit?.exam_schedule?.exam_date
                                      ).toLocaleDateString()}
                                    </span>
                                  </p>
                                  <p>
                                    Exam Start Time
                                    <span>
                                      {
                                        examdata?.exam_booking_audit
                                          ?.exam_schedule?.start_time
                                      }
                                    </span>
                                  </p>
                                  <p>
                                    Exam End Time
                                    <span>
                                      {
                                        examdata?.exam_booking_audit
                                          ?.exam_schedule?.end_time
                                      }
                                    </span>
                                  </p>
                                  <p>
                                    Age<span>{examdata?.class?.Age_Group}</span>
                                  </p>

                                  <div>
                                    {examdata?.exam_booking_audit?.exam_booking?.status === "cancel" ? (
                                        <div className="">
                                        <p> Status<span className="text-danger">Cancel</span>
                                  </p>
                                  </div>
                                    ) : examdata?.exam_booking_audit?.exam_booking?.status === "reschedule" ? (
                                        <div className="d-flex align-items-end book_slot">
                                      <span className="text-warning">
                                        Pending approval for reschedule
                                      </span>
                                      </div>
                                    ) : (
                                      <div className="d-flex align-items-end book_slot">
                                        {Array.isArray(examdata?.exam_booking_audit?.result) &&
      examdata?.exam_booking_audit?.result.length === 0 && (
                                        <>
                                        <button
                                          className="d-flex align-items-center btn btn-primary me-2 button_white_background_color"
                                          onClick={() =>
                                            handleCancelApi(
                                              examdata?.exam_booking_audit
                                                ?.booking_id
                                            )
                                          }
                                          disabled={
                                            loadingcancel[
                                              examdata?.exam_booking_audit
                                                ?.booking_id
                                            ]
                                          }
                                        >
                                          {loadingcancel[
                                            examdata?.exam_booking_audit
                                              ?.booking_id
                                          ]
                                            ? "Cancel..."
                                            : "Cancel"}
                                        </button>
                                        <button
                                          className="d-flex align-items-center btn btn-primary"
                                          onClick={() =>
                                            handleReschedule(
                                              examdata?.exam_booking_audit
                                                ?.booking_id,
                                              examdata?.id
                                            )
                                          }
                                        >
                                          {loading[
                                            examdata?.exam_booking_audit
                                              ?.booking_id
                                          ]
                                            ? "Rescheduling..."
                                            : "Reschedule"}
                                        </button>
                                        </>
                                        )}
                                          
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>

                    {success && (
                      <div className="alert alert-success mt-3">
                        Enquiry submitted successfully!
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
        ) : (
          <div className="content row d-flex justify-content-center align-items-center background-color_row_1">
            <Header />
            <ImageWithBasePath
              src="assets/img/nodata.gif"
              className="img-fluid"
              alt="img"
              width={200}
            />
          </div>

        )}
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default Examschedule;
